<div class="d-flex flex-column flex-root _bg-primary" id="kt_app_root">
  <div class="d-flex flex-column flex-center flex-column-fluid">
    <!--begin::Content-->
    <div class="d-flex flex-column flex-center p-10 w-100">
      <!--begin::Wrapper-->
      <div class="card card-flush w-md-500px py-5 w-100">
        <div class="card-body ">
          <!--begin::Logo-->
          <div class="mb-10 text-center">
            <a [routerLink]="['/']" class="">
              <img
                alt="Logo"
                src="./assets/media/logos/equipefy-logo.png"
                class="h-30px"
              />
            </a>
          </div>
          <!--end::Logo-->
          <router-outlet></router-outlet>
        </div>
      </div>
      <!--end::Wrapper-->
    </div>
    <!--end::Content-->
  </div>
</div>
